import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import Button from "../../shared/button/Btn";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { showModal } from "../../../features/modal/modalSlice";
import { useScrollLock } from "../../../hooks/useScrollLock";
import PageTopTitle from "../../shared/PageTopTitle";
import { adminUpdateDocumentTrailer, adminUpdateDocumentTruck } from "../../../features/admin2/admin2Slice";
import { useState } from "react";
import question from "../../../images/svg/question.svg"
import { coopUpdateDocumentTrailer } from "../../../features/uyelerAraclar/uyelerAraclarSlice";

const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;

  .modal {
    width: auto;
    height: 700px;
    color: ${({ theme }) => theme.mainTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
    border-radius: 10px;
    padding-block: 20px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .content {
      padding: 20px;
      h3{
        margin-bottom: 20px;
      }
      .belge-list{
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 20px;
          .belge-item{
            display: flex;
            flex-direction: column;
            width: 485px;
            height: 420px;  
            border-radius: 10px;
            padding: 0 20px;
            background-color: ${({ theme }) => theme.secondaryBgColor};

            .belge-top{
              width: 100%;
              height: 40px;
              display: flex;
              align-items: center;
              font-size: 16px;
              padding: 10px 0;
              font-weight: var(--font-weight-lg);
              border-bottom: 1px solid ${({theme})=> theme.mainBorderColor};
            }
            .belge-img{
              width: 100%;
              height: calc(100% - 100px);
              object-fit: cover;
            }

            .belge-bottom{
              width: 100%;
              height: 60px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              border-top: 1px solid ${({theme})=> theme.mainBorderColor};
                .file-input-label{
                  width: auto;
                  padding: 0 15px;
                  line-height: 40px;
                  text-align: center;
                  height: 40px;
                  color: ${({ theme }) => theme.mainTextColor};
                  border-radius: 10px;
                  font-weight: var(--font-weight-lg);
                  font-size: 16px;
                  border: 1px solid;
                  cursor: pointer;
                  border-color: ${({ theme }) => theme.contrastColor};
                }
                .file-name{
                  font-weight: var(--font-weight-md);
                  font-size: 14px;
                }

                .file-input{
                  display: none;
                }
            }
          }
        }
    }
    .btn {
      padding-inline: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        margin-inline: 10px;
      }
    }
  }
`;

const KooperatifDorseBelgeIslemlerModal = () => {
  const { modalLocation } = useSelector((state) => state.modal);
  const { selectAdminArac, adminTrailerDocs } = useSelector((state) => state.admin2);
  const dispatch = useDispatch();
  const location = useLocation();
  const { lockScroll, unlockScroll } = useScrollLock();

  //! görsel states
  const [ruhsat, setRuhsat] = useState("")
  const [tasitKarti, setTasitKarti] = useState("")
  const [saseFoto, setSaseFoto] = useState("")

  const url = "https://egeyurtgrupbucket.s3.eu-north-1.amazonaws.com/Images/"

  // //! bu modal açıldığnda ekran ı lock lamak için
  useEffect(() => {
    lockScroll();

    return () => {
      unlockScroll();
    };
  }, [lockScroll, unlockScroll]);

  // //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
  useEffect(() => {
    if (location.pathname !== modalLocation) {
      dispatch(showModal(null));
    }
  }, [dispatch, location.pathname, modalLocation]);


  const handleRuhsatSubmit = () => {
    if(ruhsat){
      const updatedTruckDoc = {
          userName: selectAdminArac.truckPlateNumber,
          documentType: "ruhsat",
          imageFile: ruhsat
    }
    dispatch(coopUpdateDocumentTrailer(updatedTruckDoc))
    }
  }

  const handleTasitKartiSubmit = () => {
    if(tasitKarti){
      const updatedTruckDoc = {
          userName: selectAdminArac.truckPlateNumber,
          documentType: "TasitKartiPhoto",
          imageFile: tasitKarti
    }
    dispatch(coopUpdateDocumentTrailer(updatedTruckDoc))
    }
  }

  const handleSaseFotoSubmit = () => {
    if(saseFoto){
      const updatedTruckDoc = {
          userName: selectAdminArac.truckPlateNumber,
          documentType: "SasePhoto",
          imageFile: saseFoto
    }
    dispatch(coopUpdateDocumentTrailer(updatedTruckDoc))
    }
  }

  return (
    <Container onClick={() => dispatch(showModal(null))}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <PageTopTitle title={"Araç Belgeleri"} />
        <div className="content">
            <h3>Plaka: {selectAdminArac?.truckPlateNumber}</h3>

            <div className="belge-list">
              <div className="belge-item">
                <div className="belge-top">Ruhsat</div>
                <img src={(ruhsat && URL.createObjectURL(ruhsat)) || (adminTrailerDocs?.ruhsatPhoto ? `${url}${adminTrailerDocs?.ruhsatPhoto}` : question)} className="belge-img" alt="kimlik" />
                <div className="belge-bottom">
                    <label className="file-input-label" htmlFor="ruhsat">Belge Seç</label>
                    <div className="file-name">{ruhsat.name || "Belge Seçin"}</div>
                    <input type="file" id="ruhsat" className='file-input' onChange={(e) => setRuhsat(e.target.files[0])} />
                    {
                        ruhsat &&
                        <Button bgColor="transparent" color="#E85446" padding="0 10px" handleClick={handleRuhsatSubmit}>Belge Ekle</Button>
                    }
                </div>
              </div>

              <div className="belge-item">
                <div className="belge-top">Taşıt Kartı</div>
                <img src={(tasitKarti && URL.createObjectURL(tasitKarti)) || (adminTrailerDocs?.tasitKartiPhoto ? `${url}${adminTrailerDocs?.tasitKartiPhoto}` : question)} className="belge-img" alt="kimlik" />
                <div className="belge-bottom">
                    <label className="file-input-label" htmlFor="tasitKarti">Belge Seç</label>
                    <div className="file-name">{tasitKarti.name || "Belge Seçin"}</div>
                    <input type="file" id="tasitKarti" className='file-input' onChange={(e) => setTasitKarti(e.target.files[0])} />
                    {
                        tasitKarti &&
                        <Button bgColor="transparent" color="#E85446" padding="0 10px" handleClick={handleTasitKartiSubmit}>Belge Ekle</Button>
                    }
                </div>
              </div>

              <div className="belge-item">
                <div className="belge-top">Şase Fotoğrafı</div>
                <img src={(saseFoto && URL.createObjectURL(saseFoto)) || (adminTrailerDocs?.sasePhoto ? `${url}${adminTrailerDocs?.sasePhoto}` : question)} className="belge-img" alt="kimlik" />
                <div className="belge-bottom">
                    <label className="file-input-label" htmlFor="saseFoto">Belge Seç</label>
                    <div className="file-name">{saseFoto.name || "Belge Seçin"}</div>
                    <input type="file" id="saseFoto" className='file-input' onChange={(e) => setSaseFoto(e.target.files[0])} />
                    {
                        saseFoto &&
                        <Button bgColor="transparent" color="#E85446" padding="0 10px" handleClick={handleSaseFotoSubmit}>Belge Ekle</Button>
                    }
                </div>
              </div>

            </div>
            
        </div>
        <div className="btn">
          <Button width="150px" handleClick={() => dispatch(showModal(null))} padding="10px" bgColor="#E85446" color={"#fff"}>
            Kapat
          </Button>
        </div>
      </div>
    </Container>
  );
};

export default KooperatifDorseBelgeIslemlerModal;
